// extracted by mini-css-extract-plugin
export default {"rowItem":"UserTable_rowItem__gAAPi","item":"UserTable_item__jCeUv","title":"UserTable_title__-nUJ1","value":"UserTable_value__8pC6b","antTableRow":"UserTable_antTableRow__F8pOW"};